import React from 'react';
import { ArrowUpRightIcon, HammerIcon, NewspaperIcon, QuoteIcon } from 'lucide-react';
import { LINKS } from '../data/site';
export function TrustBand() {
  return <section className="border-b border-steel-200 bg-white" aria-label="Why metal workers come to Fournier" data-id="element-238" data-mp="39zmqeu7g9vhp">
      <div className="mx-auto grid max-w-[1240px] divide-y divide-steel-200 px-5 sm:px-8 md:grid-cols-3 md:divide-x md:divide-y-0" data-id="element-239" data-mp="3iyhsbu3gojf7">
        <div className="py-7 md:pr-8" data-id="element-240" data-mp="2m9a7koao2ecc">
          <HammerIcon aria-hidden="true" className="h-5 w-5 text-fred" data-id="element-241" data-mp="2m64i37y4lag3" />
          <h2 className="mt-3 font-display text-[22px] uppercase leading-tight text-charcoal" data-id="element-242" data-mp="2r83okqp5wnh9">
            Established in 1991
          </h2>
          <p className="mt-2 max-w-[34ch] text-[15px] leading-relaxed text-steel-600" data-id="element-243" data-mp="2v72r64nf885j">
            A metal shaping tradition carried forward.
          </p>
          <a href={LINKS.story} className="mt-3 inline-flex min-h-[44px] items-center gap-2 text-[14px] font-medium uppercase tracking-[0.1em] text-charcoal transition-colors duration-150 ease-out hover:text-fred" data-id="element-244" data-mp="23gy8qbj81v6y">
            Our story
            <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-245" data-mp="1vz097rsxqu9n" />
          </a>
        </div>

        <div className="py-7 md:px-8" data-id="element-246" data-mp="1r81qklkh5k38">
          <NewspaperIcon aria-hidden="true" className="h-5 w-5 text-fred" data-id="element-247" data-mp="1r6yv00c7itgz" />
          <h2 className="mt-3 font-display text-[22px] uppercase leading-tight text-charcoal" data-id="element-248" data-mp="1m8xg7rltdgbb">
            Featured in Road &amp; Track
          </h2>
          <p className="mt-2 max-w-[34ch] text-[15px] leading-relaxed text-steel-600" data-id="element-249" data-mp="1d921xdwyp572">
            “The English Wheel” · August 2015
          </p>
          <a href={LINKS.roadAndTrackFeature} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex min-h-[44px] items-center gap-2 text-[14px] font-medium uppercase tracking-[0.1em] text-charcoal transition-colors duration-150 ease-out hover:text-fred" data-id="element-250" data-mp="18aqpqwj72ilo">
            Read the feature
            <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-251" data-mp="vzzp56ygvxou" />
          </a>
        </div>

        <div className="py-7 md:pl-8" data-id="element-252" data-mp="10qyawm285nzh">
          <QuoteIcon aria-hidden="true" className="h-5 w-5 text-fred" data-id="element-253" data-mp="10rzj8iruvwdi" />
          <blockquote className="mt-3 max-w-[34ch] text-[16px] leading-relaxed text-charcoal" data-id="element-254" data-mp="m2l9vaoa5ey4">
            “Jeff was great, very patient with me…”
          </blockquote>
          <p className="mt-2 text-[14px] text-steel-600" data-id="element-255" data-mp="1eqh3g6ijyqqo">Marshall Banks · Workshop student</p>
          <a href={LINKS.testimonials} className="mt-3 inline-flex min-h-[44px] items-center gap-2 text-[14px] font-medium uppercase tracking-[0.1em] text-charcoal transition-colors duration-150 ease-out hover:text-fred" data-id="element-256" data-mp="1jpagjxtxgfqb">
            Read customer stories
            <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-257" data-mp="19sxo13a4c7x5" />
          </a>
        </div>
      </div>
    </section>;
}